import { RcClasses } from '../../../../foundation';
export var RcCardActionAreaClasses = RcClasses(['root', 'focusHighlight', 'focusVisible', 'disableRipple'], 'RcCardActionArea');
export var RcCardActionAreaRippleClasses = RcClasses(['root', 'rippleVisible'], 'RcCardActionAreaTouchRipple');
